"use client";

import Image from "next/image";
import cat from "../../assets/images/cat.svg";
import chicken from "../../assets/images/chicken.svg";
import cow from "../../assets/images/cow.svg";
import cowsProduct from "../../assets/images/cowsProduct.svg";
import dog from "../../assets/images/dog.svg";
import fish from "../../assets/images/fish.svg";
import sheep from "../../assets/images/sheep.svg";
import sideCardCat from "../../assets/images/sideCardCat.svg";
import sideCardChicken from "../../assets/images/sideCardChicken.svg";
import sideCardCow from "../../assets/images/sideCardCow.svg";
import sideCardDog from "../../assets/images/sideCardDog.svg";
import sideCardFish from "../../assets/images/sideCardFish.svg";
import sideCardSheep from "../../assets/images/sideCardSheep.svg";
import backgroundShape1 from "../../assets/images/backgroundShape1.svg";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/navigation";

export default function Product() {
  const { t, i18n } = useTranslation();
  const router = useRouter();
  const categories = [
    { id: 1, image: sheep, title: "sheep" },
    { id: 2, image: chicken, title: "chicken" },
    { id: 3, image: cow, title: "cow" },
    { id: 4, image: fish, title: "fish" },
    { id: 5, image: cat, title: "cat" },
    { id: 6, image: dog, title: "dog" },
  ];
  const tableData = [
    {
      desc: "برای گونه بالغ (مقاوم‌ترند)",
      source: "FDA | ppb",
      max: "30000",
      toxin: "فومونیسین‌ها، مجموع B1 و B2 و B3",
      bg: "bg-white",
    },
    {
      desc: "آفلاتوکسین B1 بسیار سمی و خطرناک",
      source: "FDA | ppb",
      max: "20",
      toxin: "آفلاتوکسین کل",
      bg: "bg-[#F9F9F9]",
    },
    {
      desc: "تحمل بیشتر به دلیل تجزیه در شکمبه",
      source: "FDA | ppb",
      max: "250 تا 500",
      toxin: "زیرالنون",
      bg: "bg-white",
    },
    {
      desc: "مقاومت بیشتر به دلیل تجزیه شکمبه‌ای",
      source: "FDA | ppb",
      max: "250 تا 500",
      toxin: "Ht2 & T2",
      bg: "bg-[#F9F9F9]",
    },
    {
      desc: "مقاومت بیشتر به دلیل تجزیه شکمبه‌ای",
      source: "FDA | ppb",
      max: "5000 تا 10000",
      toxin: "دی اکسی نیوالنول",
      bg: "bg-white",
    },
    {
      desc: "مقاومت بیشتر به دلیل تجزیه شکمبه‌ای",
      source: "FDA | ppb",
      max: "30000",
      toxin: "اکراتوکسین A",
      bg: "bg-[#F9F9F9]",
    },
  ];

  return (
    <div
      style={{
        backgroundColor: "#EAF6FF",
        backgroundImage: `
                url(${backgroundShape1.src})`,
        backgroundSize: "100% auto",
        backgroundPosition: "top center",
        backgroundRepeat: "repeat",
      }}
      className="flex flex-col gap-8 md:gap-10 h-full bg-transparent w-full font-sans text-[#003477] px-4 pb-10"
    >
      <section className="relative flex flex-col md:flex-row w-full justify-center m-auto py-8">
        <div className="flex relative w-full md:w-1/3 flex-col justify-center items-center md:items-start -ml-24">
          <h2 className="text-xl md:text-2xl font-bold text-[#43CA71] mb-1 mx-6">Bind</h2>
          <h2 className="text-2xl md:text-3xl font-bold text-[#43CA71] mb-4 mx-12">NOVITOX</h2>
          <p className="mb-6 text-center md:text-center rounded-2xl mx-6">
            <span className="text-3xl font-bold">{t("product.title")}</span>
          </p>
          <span className="fonnt-pe flex text-center md:text-center rounded-2xl text-xl font-bold gap-3 items-center mx-6">
            <svg
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 10.7321C-0.333333 9.96225 -0.333333 8.03775 1 7.26795L13 0.339746C14.3333 -0.430054 16 0.532197 16 2.0718L16 15.9282C16 17.4678 14.3333 18.4301 13 17.6603L1 10.7321Z"
                fill="#43CA71"
              />
            </svg>
            {t("product.subtitle")}
          </span>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-6 z-20">
            {categories.map((category) => (
              <div
                key={category.id}
                onClick={() => {
                  router.push(`/product-category/${category.id}`);
                }}
                className="flex flex-col items-center cursor-pointer"
              >
                <div className="w-16 h-16 md:w-32 md:h-32 relative rounded-lg overflow-hidden transition-transform duration-300 hover:scale-105">
                  <Image
                    src={category.image}
                    alt={category.title}
                    layout="fill"
                    objectFit="fill"
                    className="rounded-3xl bg-white p-4 flex flex-col items-center "
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex relative w-full md:w-[600px] justify-center mt-8 md:mt-0">
          <div className="relative w-64 h-64 md:w-[100%] md:h-[100%]">
            <Image
              className="absolute z-10 transform translate-x-4 md:translate-x-2"
              src={cowsProduct}
              layout="fill"
              objectFit="contain"
              alt="Sample Product 1"
            />
            <Image
              className="absolute transform -translate-x-10 md:-translate-x-30"
              src={cowsProduct}
              layout="fill"
              objectFit="contain"
              alt="Sample Product 2"
            />
          </div>
        </div>
      </section>

      <section className="flex w-full justify-center items-center my-8 md:my-0">
        <div className="w-full md:w-1/2 text-[#003477] text-justify text-sm md:text-base leading-loose p-4 ">
          {t("product.description")}
        </div>
      </section>

      <section className="w-full py-8 px-4 text-center rounded-lg  mb-8 md:mb-0">
        <h2 className="text-xl md:text-2xl font-bold mb-4">{t("uniqueCharacteristics.title")}</h2>
        <ul>
          <li>{t("uniqueCharacteristics.subDesc1")}</li>
          <li>{t("uniqueCharacteristics.subDesc2")}</li>
          <li>{t("uniqueCharacteristics.subDesc3")}</li>
        </ul>
      </section>

      <section id="section-3" className="w-full py-8 px-4 md:px-10 rounded-lg">
        <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
          سطوح قابل تحمل مایکوتوکسین ها در گاوهای شیری
        </h2>

        <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
          <div className="p-6 flex items-center justify-center">
            <div className="flex w-full mx-auto">
              <div className="w-full md:w-1/3 flex justify-center">
                <Image
                  src={sideCardCow.src}
                  alt="cows"
                  width={350}
                  height={1000}
                  className="rounded-lg"
                />
              </div>
              <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                <thead>
                  <tr>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      نوع مایکوتوکسین
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      حداکثر سطح قابل تحمل
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      واحد | منبع
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      توضیحات
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.toxin}
                      </td>
                      <td className="px-4 py-1 w-fit bg-[#43CA71] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.max}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.source}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.desc}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section id="section-4" className="w-full py-8 px-4 md:px-10 rounded-lg">
        <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
          سطوح قابل تحمل مایکوتوکسین ها در گوسفند
        </h2>

        <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
          <div className="p-6 flex items-center justify-center">
            <div className="flex w-full mx-auto">
              <div className="w-full md:w-1/3 flex justify-center">
                <Image
                  src={sideCardSheep.src}
                  alt="cows"
                  width={350}
                  height={1000}
                  className="rounded-lg"
                />
              </div>
              <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                <thead>
                  <tr>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      نوع مایکوتوکسین
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      حداکثر سطح قابل تحمل
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      واحد | منبع
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      توضیحات
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.toxin}
                      </td>
                      <td className="px-4 py-1 w-fit bg-[#ACD00E] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.max}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.source}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.desc}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section id="section-5" className="w-full py-8 px-4 md:px-10 rounded-lg">
        <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
          سطوح قابل تحمل مایکوتوکسین ها در طیور
        </h2>

        <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
          <div className="p-6 flex items-center justify-center">
            <div className="flex w-full mx-auto">
              <div className="w-full md:w-1/3 flex justify-center">
                <Image
                  src={sideCardChicken.src}
                  alt="cows"
                  width={350}
                  height={1000}
                  className="rounded-lg"
                />
              </div>
              <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                <thead>
                  <tr>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      نوع مایکوتوکسین
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      حداکثر سطح قابل تحمل
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      واحد | منبع
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      توضیحات
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.toxin}
                      </td>
                      <td className="px-4 py-1 w-fit bg-[#E84545] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.max}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.source}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.desc}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section id="section-6" className="w-full py-8 px-4 md:px-10 rounded-lg">
        <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
          سطوح قابل تحمل مایکوتوکسین ها در طیور
        </h2>

        <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
          <div className="p-6 flex items-center justify-center">
            <div className="flex w-full mx-auto">
              <div className="w-full md:w-1/3 flex justify-center">
                <Image
                  src={sideCardCat.src}
                  alt="cows"
                  width={350}
                  height={1000}
                  className="rounded-lg"
                />
              </div>
              <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                <thead>
                  <tr>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      نوع مایکوتوکسین
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      حداکثر سطح قابل تحمل
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      واحد | منبع
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      توضیحات
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.toxin}
                      </td>
                      <td className="px-4 py-1 w-fit bg-[#F7941D] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.max}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.source}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.desc}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section id="section-7" className="w-full py-8 px-4 md:px-10 rounded-lg">
        <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
          سطوح قابل تحمل مایکوتوکسین ها در طیور
        </h2>

        <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
          <div className="p-6 flex items-center justify-center">
            <div className="flex w-full mx-auto">
              <div className="w-full md:w-1/3 flex justify-center">
                <Image
                  src={sideCardDog.src}
                  alt="cows"
                  width={350}
                  height={1000}
                  className="rounded-lg"
                />
              </div>
              <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                <thead>
                  <tr>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      نوع مایکوتوکسین
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      حداکثر سطح قابل تحمل
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      واحد | منبع
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      توضیحات
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.toxin}
                      </td>
                      <td className="px-4 py-1 w-fit bg-[#3870FF] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.max}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.source}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.desc}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section id="section-8" className="w-full py-8 px-4 md:px-10 rounded-lg">
        <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
          سطوح قابل تحمل مایکوتوکسین ها در طیور
        </h2>

        <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
          <div className="p-6 flex items-center justify-center">
            <div className="flex w-full mx-auto">
              <div className="w-full md:w-1/3 flex justify-center">
                <Image
                  src={sideCardFish.src}
                  alt="cows"
                  width={350}
                  height={1000}
                  className="rounded-lg"
                />
              </div>
              <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                <thead>
                  <tr>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      نوع مایکوتوکسین
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      حداکثر سطح قابل تحمل
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      واحد | منبع
                    </th>
                    <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                      توضیحات
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.toxin}
                      </td>
                      <td className="px-4 py-1 w-fit bg-[#C192FF] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.max}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.source}
                      </td>
                      <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        {row.desc}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <div className="flex w-full justify-center items-center gap-40 text-lg py-8 px-4 md:px-10 rounded-lg">
        <div className="flex flex-col gap-8">
          <span className="text-4xl text-[#3C434A]">{t("needHelp")}</span>
          <span className="text-2xl text-[#3C434A]">{t("needHelpDesc")}</span>
        </div>
        <div className="flex flex-col gap-2.5">
          <button className="flex border-none bg-[#003477] text-2xl  px-8 py-5 text-white rounded-lg">
            {t("callUs")}
          </button>
          <button className="flex border-none bg-[#003477] text-2xl  px-8 py-5 text-white rounded-lg">
            {t("sendTicket")}
          </button>
        </div>
      </div>
    </div>
  );
}
